import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/index/index.vue')
  },
  {
    path: '/case',
    name: 'case',
    component: () => import(/* webpackChunkName: "about" */ '../views/case/index.vue')
  },
  {
    path: '/caseList',
    name: 'caseList',
    component: () => import(/* webpackChunkName: "about" */ '../views/caseList/index.vue')
  },
  {
    path: '/kcList',
    name: 'kcList',
    component: () => import(/* webpackChunkName: "about" */ '../views/kcList/index.vue')
  },
  {
    path: '/addwt',
    name: 'addwt',
    component: () => import(/* webpackChunkName: "about" */ '../views/addwt/index.vue')
  },
  {
    path: '/addwthf',
    name: 'addwthf',
    component: () => import(/* webpackChunkName: "about" */ '../views/addwthf/index.vue')
  },
  {
    path: '/addpj',
    name: 'addpj',
    component: () => import(/* webpackChunkName: "about" */ '../views/addpj/index.vue')
  },
  {
    path: '/kcpjlist',
    name: 'kcpjlist',
    component: () => import(/* webpackChunkName: "about" */ '../views/kcpjlist/index.vue')
  },
  {
    path: '/wdlist',
    name: 'wdlist',
    component: () => import(/* webpackChunkName: "about" */ '../views/wdlist/index.vue')
  },
  {
    path: '/kcinfo',
    name: 'kcinfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/kcinfo/index.vue')
  },
  {
    path: '/kcstu',
    name: 'kcstu',
    component: () => import(/* webpackChunkName: "about" */ '../views/kcstu/index.vue')
  },
  {
    path: '/kcdetail',
    name: 'kcdetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/kcdetail/index.vue')
  },
  {
    path: '/libraryDetail',
    name: 'libraryDetail',
    component: () => import(/* webpackChunkName: "libraryDetail" */ '../views/libraryDetail/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import(/* webpackChunkName: "about" */ '../views/info/index.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/product/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about/index.vue')
  },
  {
    path: '/computer',
    name: 'computer',
    component: () => import(/* webpackChunkName: "computer" */ '../views/computer/index.vue')
  },

]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
